import { createReducer } from "reduxsauce"
import { takeLatest, select, call, getContext } from "redux-saga/effects"
import { get, findIndex, without, forEach } from "lodash"
import { Types as LoaderTypes } from "model/data"
import { Types as MarketToolsTypes } from "modules/market-tools/model"
import actionCreator from "helpers/actionCreator"
import { getUserPreference } from "helpers/userPreferences"
import { createDefaultReducer } from "helpers/reducers"

export const { Types, Creators } = actionCreator("ompnt/modules/factorTrends", {
  setPeriod: ["period"],
  setDate: ["date"],
  resetDate: [],
  selectDisplayType: ["display"],
})

const DEFAULT_STATE = {
  category: "style",
  focusedChartLine: null,
  disabled: {},
  only: null,
  selectedViews: [],
  period: "1Y",
  date: null,
}

export const handleLoadSuccess = (state, action) => {
  if (action.resource === "factorTrendsUserPreferences") {
    const { selectedViews } = getUserPreference(action.data, "factorTrends", {})
    return { ...state, selectedViews: selectedViews || [] }
  } else {
    return state
  }
}

export default createReducer(DEFAULT_STATE, {
  [LoaderTypes.LOAD_SUCCESS]: handleLoadSuccess,
})

function handleSetPeriod(state, { period }) {
  const { startDate, endDate } = period
  const newPeriod = !startDate && !endDate ? period : null

  let { date } = state
  if (date && (date < startDate || date > endDate)) {
    date = null
  }

  return {
    ...state,
    date,
    startDate,
    endDate,
    period: newPeriod,
  }
}

function handleSetFactorCategory(state, { category }) {
  return {
    ...state,
    factorCategory: category,
    only: null,
  }
}

function handleAddSelectedView(state, { factorId }) {
  return {
    ...state,
    views: [...(state.views || []), factorId],
    factorCategory: factorId,
  }
}

function handleRemoveSelectedView(state, { factorId, options }) {
  let { factorCategory } = state
  if (factorCategory === factorId) {
    const optionIndex = findIndex(options, option => option.id === factorId)
    factorCategory = get(options, `${optionIndex - 1}.id`)
  }

  return {
    ...state,
    factorCategory,
    views: without(state.views, factorId),
  }
}

function handleSetModel(state) {
  return {
    ...state,
    only: null,
    disabled: [],
  }
}

const handleToggleQS = (state, { id, currentState }) => {
  return {
    ...state,
    only: null,
    disabled: currentState ? without(state.disabled, id) : [...(state.disabled || []), id],
  }
}

const handleToggleOnlyQS = (state, { id, only, items }) => {
  const disabled = []
  let onlyDisplay = null

  if (only) {
    onlyDisplay = id
    forEach(items, item => {
      if (item.id !== id) {
        disabled.push(item.id)
      }
    })
  }

  return { ...state, disabled, only: onlyDisplay }
}

export const queryStringReducers = {
  [Types.SET_PERIOD]: handleSetPeriod,
  [Types.SET_DATE]: createDefaultReducer(),
  [Types.RESET_DATE]: createDefaultReducer({ customStateValues: { date: null } }),
  [Types.SET_FACTOR_CATEGORY]: handleSetFactorCategory,
  [Types.ADD_SELECTED_VIEW]: handleAddSelectedView,
  [Types.REMOVE_SELECTED_VIEW]: handleRemoveSelectedView,
  [Types.TOGGLE]: handleToggleQS,
  [Types.TOGGLE_ONLY]: handleToggleOnlyQS,
  [MarketToolsTypes.SET_MODEL]: handleSetModel,
}

function* handleSelectDisplayType({ display }) {
  const account = yield select(state => get(state, "global.selected.account"))
  const url = `/${account}/home/market/factors/${get(display, "id")}`
  const { navigate } = yield getContext("router")
  yield call(navigate, url)
}

export function* saga() {
  yield takeLatest(Types.SELECT_DISPLAY_TYPE, handleSelectDisplayType)
}
